export var formContent = '_296On';
export var icon = '_1AYCf';
export var input = '$_2R1Cf';
export var backgroundImage = '_21eNw';